// apps/landing-page/src/lib/exam-talent.ts

// Single registry of every brand cut-out in public/talent (AI-generated talent,
// never presented as a real student). Components import their figure from here
// and talent-assets.test.ts checks each declared size against the real file, so
// swapping an asset is one line. Cut-outs are cropped at the waist or knees and
// must sit flush on the bottom edge of a clipping container.
export interface TalentFigure {
  src: string;
  width: number;
  height: number;
}

export interface ExamTalent extends TalentFigure {
  // Distance from the card's right edge in px (default 8). Per-figure data for
  // poses whose raised hand would otherwise reach the text.
  right?: number;
}

const figure = (name: string, width: number, height: number): TalentFigure => ({
  src: `/talent/${name}.webp`,
  width,
  height,
});

// Exam-card figures, keyed by exam-type slug.
const EXAM_TALENT = new Map<string, ExamTalent>([
  ['utbk', figure('talent-siswi-utbk-1', 459, 800)],
  ['tka', { ...figure('talent-siswa-tka-1', 474, 800), right: 0 }],
  ['toefl', figure('talent-mahasiswa-toefl-1', 359, 800)],
  ['cpns', figure('talent-umum-pria-cpns-1', 408, 800)],
  ['psikotes', figure('talent-umum-psikotes-1', 426, 800)],
]);

// Page-level figures.
export const TALENT_DUO_HERO = figure('talent-duo-hero-2', 1096, 1200);
// Half-body crop (head to just below the belt) for the md-to-lg hero slot.
export const TALENT_SOLO_HERO = figure('talent-siswa-hero-2-half', 1118, 1010);
export const TALENT_DUO_CLOSING = figure('talent-duo-closing-1', 955, 800);
export const TALENT_FAQ = figure('talent-mahasiswa-faq-1-half', 490, 800);

export const TALENT_FIGURES: readonly TalentFigure[] = [
  ...EXAM_TALENT.values(),
  TALENT_DUO_HERO,
  TALENT_SOLO_HERO,
  TALENT_DUO_CLOSING,
  TALENT_FAQ,
];

// Unlike examIcon there is no fallback: an exam family without a persona keeps
// the faint icon motif. A Map, so `constructor` and friends are not figures.
export function examTalent(slug: string): ExamTalent | null {
  return EXAM_TALENT.get(slug) ?? null;
}
